/* ============================================================
   DANAMI E-Commerce — JavaScript principal
   ============================================================ */

(function () {
  'use strict';

  // ── Utilidades ──────────────────────────────────────────────
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  function money(cents) {
    const format = window.DANAMI?.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace('{{amount}}', amount);
  }

  function toast(msg, type = 'default') {
    const container = $('#toast-container') || createToastContainer();
    const el = document.createElement('div');
    el.className = `toast toast--${type}`;
    el.textContent = msg;
    container.appendChild(el);
    setTimeout(() => el.remove(), 3200);
  }

  function createToastContainer() {
    const div = document.createElement('div');
    div.id = 'toast-container';
    div.className = 'toast-container';
    document.body.appendChild(div);
    return div;
  }

  // ── Menú móvil ──────────────────────────────────────────────
  function initMobileMenu() {
    const toggle = $('[data-menu-toggle]');
    const nav = $('#mobile-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen);
      nav.setAttribute('aria-hidden', !isOpen);
    });
  }

  // ── Cart Drawer ─────────────────────────────────────────────
  const CartDrawer = {
    drawer: null,
    overlay: null,

    init() {
      this.drawer = $('#cart-drawer');
      this.overlay = $('#overlay');
      if (!this.drawer) return;

      $$('[data-cart-toggle]').forEach(btn =>
        btn.addEventListener('click', () => this.open())
      );
      $$('[data-cart-close]').forEach(btn =>
        btn.addEventListener('click', () => this.close())
      );
      this.overlay?.addEventListener('click', () => this.close());

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') this.close();
      });

      this.drawer.addEventListener('click', e => {
        const btn = e.target.closest('[data-qty-change]');
        if (btn) this.handleQtyChange(btn);
      });
    },

    open() {
      this.drawer.classList.add('open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay?.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },

    close() {
      this.drawer.classList.remove('open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay?.classList.remove('active');
      document.body.style.overflow = '';
    },

    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Cart refresh error:', err);
      }
    },

    render(cart) {
      const countEls = $$('[data-count], #cart-count-drawer');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });

      const totalEl = $('#cart-total');
      if (totalEl) totalEl.textContent = money(cart.total_price);

      const itemsEl = $('#cart-items');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = `
          <div class="cart-empty">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            <p>Tu carrito está vacío</p>
            <a href="/collections/kantek" class="btn btn--primary btn--sm" style="margin-top:12px;">Ver catálogo</a>
          </div>`;
        return;
      }

      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-item__img"
               src="${item.image ? item.image.replace('_1x', '_120x120_crop_center') : ''}"
               alt="${item.title}"
               loading="lazy">
          <div class="cart-item__info">
            <p class="cart-item__name">${item.product_title}</p>
            <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
            <p class="cart-item__price">${money(item.final_line_price)}</p>
            <div class="cart-item__qty">
              <button class="qty-btn" data-qty-change="-1" data-key="${item.key}" aria-label="Quitar uno">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button class="qty-btn" data-qty-change="1" data-key="${item.key}" aria-label="Agregar uno">+</button>
            </div>
          </div>
        </div>`).join('');
    },

    async handleQtyChange(btn) {
      const key = btn.dataset.key;
      const change = parseInt(btn.dataset.qtyChange, 10);
      const itemEl = btn.closest('.cart-item');
      const currentQty = parseInt(itemEl?.querySelector('.qty-value')?.textContent || '1', 10);
      const newQty = Math.max(0, currentQty + change);

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Cart change error:', err);
      }
    }
  };

  // ── Agregar al carrito ───────────────────────────────────────
  async function addToCart(variantId, quantity = 1) {
    const btn = $(`[data-variant-id="${variantId}"][data-add-to-cart]`);
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="spinner"></span>';
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });

      if (!res.ok) throw new Error('Error al agregar');

      toast('✓ Producto agregado al carrito', 'success');
      CartDrawer.open();
    } catch (err) {
      toast('Error al agregar. Intenta de nuevo.', 'error');
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          Agregar al carrito`;
      }
    }
  }

  // ── Comprar ahora (agrega y va directo al checkout) ──────────
  async function buyNow(variantId, quantity = 1, btn) {
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="spinner"></span>';
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!res.ok) throw new Error('Error');
      window.location.href = '/checkout';
    } catch (err) {
      toast('Error al procesar. Intenta de nuevo.', 'error');
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Comprar ahora';
      }
    }
  }

  function initAddToCart() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      const productCard = btn.closest('[data-product-id]');
      const select = productCard?.querySelector('[data-variant-select]');
      const variantId = select
        ? select.value
        : btn.dataset.variantId;

      if (variantId) addToCart(variantId);
    });

    // Comprar ahora
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-buy-now]');
      if (!btn) return;

      const card = btn.closest('[data-product-id]');
      const select = card?.querySelector('[data-variant-select]');
      const variantId = select
        ? select.value
        : btn.dataset.variantId;

      if (variantId) buyNow(variantId, 1, btn);
    });

    // Actualizar precio al cambiar variante
    document.addEventListener('change', e => {
      const select = e.target.closest('[data-variant-select]');
      if (!select) return;

      const option = select.selectedOptions[0];
      const price = option?.dataset.price;
      const card = select.closest('.product-card');
      const priceEl = card?.querySelector('.product-card__price');
      const addBtn = card?.querySelector('[data-add-to-cart]');

      if (price && priceEl) priceEl.textContent = money(parseInt(price, 10));
      if (addBtn) addBtn.dataset.variantId = select.value;
      const shipEl = card?.querySelector('[data-ship]');
      const grams = parseInt(option?.dataset.grams || '0', 10);
      if (shipEl) shipEl.textContent = grams >= 4000 ? '✓ Envío gratis' : '+ envío $270 · gratis desde 4 kg';
    });
  }

  // ── Tabs KANTEK / PETLINE ────────────────────────────────────
  function initBrandTabs() {
    const tabs = $$('[data-tab]');
    if (!tabs.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const brand = tab.dataset.tab;

        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        $$('[role="tabpanel"]').forEach(panel => {
          panel.hidden = panel.id !== `panel-${brand}`;
        });
      });
    });
  }

  // ── Filtros de productos ─────────────────────────────────────
  function initFilters() {
    $$('[data-filter-group]').forEach(group => {
      const targetId = group.dataset.target;
      const filterKey = group.dataset.filterGroup;
      const grid = $(`#${targetId}`);
      if (!grid) return;

      group.addEventListener('click', e => {
        const chip = e.target.closest('[data-filter]');
        if (!chip) return;

        $$('.chip', group).forEach(c => c.classList.remove('active'));
        chip.classList.add('active');

        const filterVal = chip.dataset.filter;
        const cards = $$('.product-card', grid);

        cards.forEach(card => {
          if (filterVal === 'all') {
            card.dataset.hidden = 'false';
          } else {
            const cardVal = card.dataset[filterKey] || '';
            const matches = cardVal.split(' ').includes(filterVal);
            card.dataset.hidden = (!matches).toString();
          }
        });
      });
    });
  }

  // ── Sección de Citas ─────────────────────────────────────────
  function initCitas() {
    const form = $('#cita-form');
    const formWrapper = $('#appointment-form');
    if (!form || !formWrapper) return;

    $$('[data-open-appointment]').forEach(btn => {
      btn.addEventListener('click', () => {
        const servicio = btn.dataset.openAppointment;
        $('#f-servicio').value = servicio;
        $('#appointment-form-title').textContent =
          servicio === 'grooming' ? 'Agendar: Baño y Estética 🛁' : 'Agendar: Consulta Veterinaria 🏥';

        formWrapper.style.display = 'block';
        formWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    $('[data-close-appointment]')?.addEventListener('click', () => {
      formWrapper.style.display = 'none';
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      const data = new FormData(form);

      const nombre   = data.get('nombre');
      const telefono = data.get('telefono');
      const mascota  = data.get('mascota');
      const especie  = data.get('especie');
      const fecha    = data.get('fecha');
      const hora     = data.get('hora');
      const notas    = data.get('notas');
      const servicio = data.get('servicio');

      const servicioLabel = servicio === 'grooming' ? '🛁 Baño y Estética' : '🏥 Consulta Veterinaria';

      const msg = `Hola, quiero agendar una cita:

📋 Servicio: ${servicioLabel}
👤 Nombre: ${nombre}
📱 Teléfono: ${telefono}
🐾 Mascota: ${mascota || 'No especificado'} (${especie || 'No especificado'})
📅 Fecha: ${fecha}
⏰ Horario preferido: ${hora} hrs
📝 Notas: ${notas || 'Sin notas'}`;

      sendLead({ formulario: servicioLabel, nombre, empresa: '', telefono, ciudad: 'Irapuato, Gto.', interes: servicioLabel, notas: notas || '' });

      const waNumber = window.DANAMI?.whatsappNumber || '524623558074';
      const waUrl = `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`;
      window.open(waUrl, '_blank', 'noopener,noreferrer');
    });
  }

  // ── Búsqueda en header ───────────────────────────────────────
  function initSearch() {
    const input = $('.header-search input');
    if (!input) return;

    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') input.blur();
    });
  }

  // ── Enviar lead a Google Script → Bind ERP + Sheet ──────────
  const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyJri93i8s9Rnk4N5mpdYo4c-gUdrLomdkHmtZlsiks_7fLUhwg4NXK5SzgIqFyrPJB/exec';

  function sendLead(data) {
    fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode:   'no-cors',
      body:   JSON.stringify(data)
    }).catch(() => {});
  }
  window.sendLead = sendLead;

  // ── Carrusel de líneas de marca ──────────────────────────────
  function initBrandCarousel() {
    $$('.brand-carousel-wrap').forEach(wrap => {
      const track = $('[data-carousel]', wrap);
      if (!track) return;
      const card = $('.brand-product-card', track);
      const step = () => (card ? card.getBoundingClientRect().width + 20 : 300);
      $('[data-carousel-prev]', wrap)?.addEventListener('click', () =>
        track.scrollBy({ left: -step(), behavior: 'smooth' }));
      $('[data-carousel-next]', wrap)?.addEventListener('click', () =>
        track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  // ── Nav Dropdown ─────────────────────────────────────────────
  function initNavDropdown() {
    document.querySelectorAll('[data-dropdown-toggle]').forEach(btn => {
      const li = btn.closest('.nav-dropdown');
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const open = li.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.nav-dropdown.is-open').forEach(el => {
        el.classList.remove('is-open');
        el.querySelector('[data-dropdown-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── Header translúcido al hacer scroll ───────────────────────
  function initStickyHeader() {
    const header = $('.site-header');
    if (!header) return;
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Init ─────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    CartDrawer.init();
    initAddToCart();
    initBrandTabs();
    initFilters();
    initCitas();
    initSearch();
    initNavDropdown();
    initBrandCarousel();
    initStickyHeader();
  });

})();
